/// <amd-module name="TFS/Admin/Groups/Pivots/Settings/Redux/SettingsPivotSelectors" />
import { IGroupsViewState, TeamAdmin } from "TFS/Admin/Groups/Common/Contracts";
import { MessageCardSeverity } from "VSSUI/MessageCard";
import { GraphGroup } from "VSS/Platform/Contracts/Graph";

export function getShowChangeImageDialog(state: IGroupsViewState): boolean | undefined {
    if (!state || !state.settingsState || !state.settingsState.showChangeImageDialog) {
        return undefined;
    }

    return state.settingsState.showChangeImageDialog;
}

export function getIsSaving(state: IGroupsViewState): boolean {
    if (!state || !state.settingsState || !state.settingsState.isSaving) {
        return false;
    }

    return state.settingsState.isSaving;
}

export function getGroupDisplayName(state: IGroupsViewState): string {
    if (!state || !state.settingsState || !state.settingsState.groupName) {
        return "";
    }

    return state.settingsState.groupName;
}

export function getGroupDescription(state: IGroupsViewState): string {
    if (!state || !state.settingsState || !state.settingsState.groupDescription) {
        return "";
    }

    return state.settingsState.groupDescription;
}

export function getDeleteAvatar(state: IGroupsViewState): boolean {
    if (!state || !state.settingsState || !state.settingsState.groupDescription) {
        return false;
    }

    return state.settingsState.deleteAvatar;
}

export function getCurrentGroupAvatarUrl(state: IGroupsViewState): string {
    if (!state || !state.settingsState || !state.settingsState.currentGroupAvatarUrl) {
        return "";
    }

    return state.settingsState.currentGroupAvatarUrl;
}

export function getIsDirty(state: IGroupsViewState): boolean {
    if (!state || !state.settingsState || !state.settingsState.isDirty) {
        return false;
    }

    return state.settingsState.isDirty;
}

export function getMessageCardText(state: IGroupsViewState): string {
    if (!state || !state.settingsState) {
        return "";
    }

    return state.settingsState.messageCardText;
}

export function getMessageCardSeverity(state: IGroupsViewState): MessageCardSeverity {
    if (!state || !state.settingsState) {
        return MessageCardSeverity.Info;
    }

    return state.settingsState.messageCardSeverity;
}

export function getDeletedGroup(state: IGroupsViewState): GraphGroup | undefined {
    if (!state || !state.settingsState) {
        return undefined;
    }

    return state.settingsState.deletedGroup;
}

export function getTeamAdmins(state: IGroupsViewState): TeamAdmin[] {
    if (!state || !state.settingsState) {
        return [];
    }

    return state.settingsState.teamAdmins;
}

export function showAddAdminPanel(state: IGroupsViewState): boolean {
    if (!state || !state.settingsState) {
        return false;
    }

    return state.settingsState.showAddAdminPanel;
}
